(function(){
  'use strict';
  var scope = document.documentElement;

  function haptique(motif){ try{ if(navigator.vibrate) navigator.vibrate(motif); }catch(e){} }
  var CURRENCY_SYMBOLS = { GBP: '£', EUR: '€', USD: '$' };
  function euros(n){
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var sym = CURRENCY_SYMBOLS[code] || (code + ' ');
    return sym + (Math.round(n * 100) / 100).toFixed(2);
  }

  /* ---------- Préchargeur ---------- */
  function initPreloader(){
    var pre = document.getElementById('amy-preloader');
    if(!pre) return;
    var mots = ['Polishing the 18K gold…','Bonding the PVD layer…','Setting the stones…','Opening the boutique…'];
    var i = 0, txt = document.getElementById('amy-charge-texte');
    var mt = setInterval(function(){ i++; if(i<mots.length && txt) txt.textContent = mots[i]; }, 450);
    function done(){ pre.classList.add('done'); clearInterval(mt); }
    window.addEventListener('load', function(){ setTimeout(done, 1200); });
    setTimeout(done, 3200);
  }

  /* ---------- Révélation au scroll ---------- */
  function initReveal(){
    var els = document.querySelectorAll('.amy-reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('visible'); }); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); io.unobserve(e.target); } }); }, {threshold:.12});
    els.forEach(function(el){ io.observe(el); });
  }

  /* ---------- Barre de progression scroll ---------- */
  function initProgress(){
    var prog = document.createElement('div'); prog.id='amy-progression'; document.body.appendChild(prog);
    window.addEventListener('scroll', function(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      prog.style.width = (h>0 ? (window.scrollY/h*100) : 0) + '%';
    }, {passive:true});
  }

  /* ---------- Boutons magnétiques ---------- */
  function initMagnetic(){
    var selector = '.amy-cta-primaire, .amy-btn-ajout, .amy-btn-panier, .amy-btn-pause-avis, .amy-lien-secondaire, [data-magnetic]';
    var boutons = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!boutons.length) return;

    boutons.forEach(function(b){ b.style.willChange = 'transform'; b.style.transition = 'transform .25s var(--spring, cubic-bezier(0.16,1,0.3,1))'; });

    var ticking = false, lastEvent = null;
    document.addEventListener('pointermove', function(e){
      lastEvent = e;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        boutons.forEach(function(b){
          var r = b.getBoundingClientRect();
          var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
          var dx = lastEvent.clientX - cx, dy = lastEvent.clientY - cy;
          var dist = Math.sqrt(dx*dx + dy*dy);
          var rayon = Math.max(r.width, r.height) * 1.4 + 40;
          if (dist < rayon) {
            var force = 1 - dist / rayon;
            b.style.transform = 'translate(' + (dx * force * 0.4) + 'px,' + (dy * force * 0.4) + 'px) scale(' + (1 + force * 0.04) + ')';
          } else if (b.style.transform) {
            b.style.transform = '';
          }
        });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Tilt cartes ---------- */
  function initTilt(){
    document.querySelectorAll('.amy-tilt').forEach(function(c){
      c.addEventListener('pointermove', function(e){
        var r=c.getBoundingClientRect();
        var x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        c.style.transform='perspective(900px) rotateY('+(x*10)+'deg) rotateX('+(-y*10)+'deg) translateY(-6px)';
      });
      c.addEventListener('pointerleave', function(){ c.style.transform=''; });
    });
  }

  /* ---------- Marquee ---------- */
  function initMarquee(){
    document.querySelectorAll('[data-amy-marquee]').forEach(function(piste){
      var mots = (piste.dataset.amyMarquee || '').split('|').filter(Boolean);
      if(!mots.length) return;
      piste.innerHTML = mots.concat(mots).map(function(m){ return '<span>'+m+'</span><span>◆</span>'; }).join('');
    });
  }

  /* ---------- Carrousel d'avis ---------- */
  function initAvis(){
    var pi = document.getElementById('amy-piste-avis'), pts = document.getElementById('amy-points-avis');
    if(!pi || !pts) return;
    var idxA = 0, nA = pi.children.length;
    for(var k=0;k<nA;k++){ (function(k){ var b=document.createElement('button'); b.setAttribute('aria-label','Avis '+(k+1)); b.onclick=function(){idxA=k;actu();}; pts.appendChild(b); })(k); }
    function actu(){
      pi.style.transform = 'translateX(-'+(idxA*(Math.min(440, window.innerWidth*0.86)+20))+'px)';
      Array.prototype.forEach.call(pts.children, function(b,i){ b.classList.toggle('actif', i===idxA); });
    }
    var pauseBtn = document.getElementById('amy-pause-avis'), timerA = null;
    function demarrer(){ if(timerA) return; timerA = setInterval(function(){ idxA=(idxA+1)%nA; actu(); }, 4200); }
    function arreter(){ if(timerA){ clearInterval(timerA); timerA=null; } }
    if(pauseBtn) pauseBtn.addEventListener('click', function(){
      var enPause = timerA !== null;
      if(enPause){ arreter(); pauseBtn.textContent='Reprendre'; } else { demarrer(); pauseBtn.textContent='Pause'; }
    });
    demarrer();
    actu();
  }

  /* ---------- Compteurs animés ---------- */
  function initCompteurs(){
    var cibles = document.querySelectorAll('[data-amy-count]');
    if(!cibles.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){
      if(!e.isIntersecting) return;
      var el=e.target; io.unobserve(el);
      var fin=parseInt(el.dataset.amyCount,10); if(isNaN(fin)) return;
      var suffix = el.dataset.amySuffix || '';
      var t0=null;
      function pas(t){ if(!t0)t0=t; var p=Math.min(1,(t-t0)/1400); var ease=1-Math.pow(1-p,4); el.textContent=Math.round(fin*ease)+suffix; if(p<1)requestAnimationFrame(pas); }
      requestAnimationFrame(pas);
    }); }, {threshold:.5});
    cibles.forEach(function(b){ io.observe(b); });
  }

  /* ---------- Newsletter (formulaire client Shopify réel) ---------- */
  function initNewsletter(){
    var fn = document.getElementById('amy-form-news');
    if(!fn) return;
    fn.addEventListener('submit', function(e){
      if(fn.dataset.amySubmitted) return;
      e.preventDefault();
      var data = new FormData(fn);
      fetch(fn.action, { method: 'POST', body: data })
        .then(function(){
          fn.innerHTML = '<p class="amy-texte-courant"><strong>Welcome to the circle.</strong> Your 10% code is on its way by email.</p>';
          haptique([15,30,10]);
        })
        .catch(function(){
          fn.dataset.amySubmitted = '1';
          fn.submit();
        });
    });
  }

  /* ---------- Panier réel Shopify ---------- */
  var Panier = (function(){
    var tiroir = document.getElementById('amy-tiroir'), voile = document.getElementById('amy-voile');
    var compte = document.getElementById('amy-compte-panier'), contenu = document.getElementById('amy-contenu-panier'), totalEl = document.getElementById('amy-panier-total');

    function rendre(cart){
      if(!compte) return;
      compte.textContent = cart.item_count;
      contenu.innerHTML = '';
      if(!cart.items.length){
        contenu.innerHTML = '<p class="amy-texte-courant" style="font-size:14px">Your bag is empty — compose your first set.</p>';
      }
      cart.items.forEach(function(item){
        var d = document.createElement('div'); d.className='amy-item-panier';
        d.innerHTML = '<span>'+item.product_title+' ('+item.quantity+')</span><b>'+euros(item.final_line_price/100)+'</b>';
        var b = document.createElement('button'); b.className='amy-btn-ajout'; b.style.minWidth='44px'; b.textContent='✕';
        b.setAttribute('aria-label','Retirer '+item.product_title);
        b.onclick = function(){ changer(item.key, 0); };
        d.appendChild(b);
        contenu.appendChild(d);
      });
      if(totalEl) totalEl.textContent = euros(cart.total_price/100);
    }

    function refresh(){
      return fetch('/cart.js').then(function(r){ return r.json(); }).then(rendre);
    }

    function ajouter(items){
      return fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({ items: items })
      }).then(function(r){ if(!r.ok) return r.json().then(function(d){ throw d; }); return r.json(); })
        .then(function(){ return refresh(); })
        .then(function(){ ouvrir(); haptique([15,30,10]); });
    }

    function changer(key, quantity){
      return fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function(r){ return r.json(); }).then(rendre);
    }

    function ouvrir(){ if(tiroir){ tiroir.classList.add('ouvert'); voile.classList.add('visible'); } }
    function fermer(){ if(tiroir){ tiroir.classList.remove('ouvert'); voile.classList.remove('visible'); } }

    if(document.getElementById('amy-ouvrir-panier')) document.getElementById('amy-ouvrir-panier').onclick = function(){ refresh(); ouvrir(); };
    if(document.getElementById('amy-fermer-panier')) document.getElementById('amy-fermer-panier').onclick = fermer;
    if(voile) voile.onclick = fermer;
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') fermer(); });

    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-amy-add]');
      if(!btn) return;
      var id = btn.dataset.amyAdd;
      if(!id) return;
      var original = btn.textContent;
      btn.textContent = '…';
      ajouter([{ id: id, quantity: 1 }])
        .then(function(){ btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = original; }, 1200); })
        .catch(function(){ btn.textContent = 'Sold out'; setTimeout(function(){ btn.textContent = original; }, 1200); });
    });

    var cmdBtn = document.getElementById('amy-cta-commander');
    if(cmdBtn) cmdBtn.addEventListener('click', function(){ window.location.href = '/checkout'; });

    refresh();
    var api = { ajouter: ajouter, ouvrir: ouvrir, refresh: refresh }; window.AmyPanier = api; return api;
  })();

  /* ---------- Atelier de stacking (réel) ---------- */
  function initAtelier(){
    document.querySelectorAll('[data-amy-atelier]').forEach(function(atelier){
      var pileEl = atelier.querySelector('[data-amy-pile]');
      var totalPrixEl = atelier.querySelector('[data-amy-total-prix]');
      var totalDetailEl = atelier.querySelector('[data-amy-total-detail]');
      var baseButtons = atelier.querySelectorAll('[data-amy-base]');
      var anneauButtons = atelier.querySelectorAll('[data-amy-anneau]');
      var ajouterBtn = atelier.querySelector('[data-amy-ajouter-parure]');
      var resetBtn = atelier.querySelector('[data-amy-reset]');
      if(!baseButtons.length) return;

      var base = baseButtons[0];
      var baseNom = base.dataset.amyBase, basePrix = parseFloat(base.dataset.amyPrix), baseVariant = base.dataset.amyVariant, baseImage = base.dataset.amyImage;
      var pile = [];

      function rendrePile(){
        pileEl.innerHTML='';
        var tailles=[140,116,96,80,68,58];
        function anneau(nom, image, i){
          var d=document.createElement('div'); d.className='amy-anneau-stack';
          var L=tailles[Math.min(i,tailles.length-1)];
          d.style.width=L+'px'; d.style.height=L+'px'; d.style.borderRadius='50%'; d.style.overflow='hidden';
          d.style.border='2px solid oklch(0.82 0.14 85 / .8)';
          d.style.boxShadow='0 18px 44px oklch(0 0 0 / .5)';
          d.style.transform='scale(.6)'; d.style.opacity='0';
          if (image) {
            var img = document.createElement('img');
            img.src = image; img.alt = nom;
            img.style.width='100%'; img.style.height='100%'; img.style.objectFit='cover';
            d.appendChild(img);
          }
          pileEl.appendChild(d);
          requestAnimationFrame(function(){ requestAnimationFrame(function(){ d.style.transform='scale(1)'; d.style.opacity='1'; }); });
        }
        anneau(baseNom, baseImage, 0);
        pile.forEach(function(p,idx){ anneau(p.nom, p.image, idx+1); });
        var total = basePrix + pile.reduce(function(a,p){return a+p.prix;},0);
        totalPrixEl.textContent = euros(total);
        totalDetailEl.textContent = 'Base '+baseNom+' · '+(pile.length+1)+' piece'+(pile.length?'s':'')+' · 18K PVD';
      }

      baseButtons.forEach(function(b){ b.addEventListener('click', function(){
        baseButtons.forEach(function(x){x.classList.remove('actif');});
        b.classList.add('actif');
        baseNom=b.dataset.amyBase; basePrix=parseFloat(b.dataset.amyPrix); baseVariant=b.dataset.amyVariant; baseImage=b.dataset.amyImage;
        haptique([15,30,10]); rendrePile();
      });});

      anneauButtons.forEach(function(b){ b.addEventListener('click', function(){
        if(pile.length>=5){ var t=b.textContent; b.textContent='Bag full'; setTimeout(function(){b.textContent=t;},1400); return; }
        pile.push({ nom:b.dataset.amyAnneau, prix:parseFloat(b.dataset.amyPrix), variant:b.dataset.amyVariant, image:b.dataset.amyImage });
        var t0=b.textContent; b.textContent='Stacked ✓'; setTimeout(function(){b.textContent=t0;},1100);
        haptique([15,30,10]); rendrePile();
      });});

      if(resetBtn) resetBtn.addEventListener('click', function(){ pile=[]; rendrePile(); });

      if(ajouterBtn) ajouterBtn.addEventListener('click', function(){
        var items = [{ id: baseVariant, quantity: 1 }].concat(pile.map(function(p){ return { id: p.variant, quantity: 1 }; }));
        ajouterBtn.textContent = '…';
        Panier.ajouter(items).then(function(){ ajouterBtn.textContent = 'Added to bag ✓'; setTimeout(function(){ ajouterBtn.innerHTML = 'Add the set to your bag <span class="amy-fleche">→</span>'; }, 1600); });
      });

      rendrePile();
    });
  }

  /* ---------- Résonateur WebGL (Three.js) ---------- */
  function initResonateur(){
    var canvas = document.getElementById('amy-resonateur-canvas');
    if(!canvas || typeof THREE === 'undefined') return;
    try{
      var renderer = new THREE.WebGLRenderer({canvas:canvas, antialias:true, alpha:true});
      var zone = canvas.closest('.amy-res-canvas-zone');
      var W=0,H=0;
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(32, 1, .1, 100); camera.position.set(0,0,9);
      function taille(){ W=zone.clientWidth; H=zone.clientHeight; renderer.setSize(W,H,false); renderer.setPixelRatio(Math.min(window.devicePixelRatio,2)); camera.aspect=W/H; camera.updateProjectionMatrix(); }
      var key = new THREE.DirectionalLight(0xfff2d0, 3.2); key.position.set(2,5,6); scene.add(key);
      var fill = new THREE.DirectionalLight(0xffe9c2, 1.8); fill.position.set(-3,1,4); scene.add(fill);
      var goldPt = new THREE.PointLight(0xffc861, 24, 30); goldPt.position.set(2,-1,4); scene.add(goldPt);
      scene.add(new THREE.AmbientLight(0x6b5a3c, 1.8));
      var orMat = new THREE.MeshPhysicalMaterial({color:0xe0b355, metalness:1, roughness:.12, clearcoat:1, clearcoatRoughness:.08});
      var jonc = new THREE.Group();
      var bande = new THREE.Mesh(new THREE.TorusGeometry(1.9,.34,48,220), orMat);
      bande.scale.set(1,.6,1);
      jonc.add(bande);
      var trimMat = new THREE.MeshPhysicalMaterial({color:0xf0cf8a, metalness:1, roughness:.16, clearcoat:1});
      [1.145,-1.145].forEach(function(off){
        var trim = new THREE.Mesh(new THREE.TorusGeometry(1.9,.04,12,220), trimMat);
        trim.position.y = off*.34;
        jonc.add(trim);
      });
      jonc.rotation.x = Math.PI/3.4; scene.add(jonc);
      var gemMat = new THREE.MeshPhysicalMaterial({color:0xeaf6ff, metalness:0, roughness:.03, transmission:.9, thickness:1, ior:2.2, clearcoat:1, transparent:true});
      var gems = new THREE.Group();
      var nClusters = 8;
      for(var g=0; g<nClusters; g++){
        var a = g/nClusters*Math.PI*2;
        var cluster = new THREE.Group();
        var offsets = [[0,0],[.09,.06],[-.09,.06],[0,-.1]];
        offsets.forEach(function(o){
          var s = new THREE.Mesh(new THREE.SphereGeometry(.045,16,16), gemMat);
          s.position.set(o[0], o[1], 0);
          cluster.add(s);
        });
        cluster.position.set(Math.cos(a)*1.9, Math.sin(a)*1.9*.28, .145);
        cluster.rotation.z = a;
        gems.add(cluster);
      }
      gems.rotation.x = Math.PI/3.4; scene.add(gems);
      var cx=0, cy=0, tx=0, ty=0;
      var caust = document.querySelector('.amy-caustique');
      zone.addEventListener('pointermove', function(e){ var r=zone.getBoundingClientRect(); tx=(e.clientX-r.left)/r.width-.5; ty=(e.clientY-r.top)/r.height-.5; if(caust){ caust.style.left=(e.clientX-r.left)+'px'; caust.style.top=(e.clientY-r.top)+'px'; } });
      taille(); window.addEventListener('resize', taille);
      var t=0;
      (function boucle(){
        requestAnimationFrame(boucle); t+=.008;
        cx += (tx-cx)*.045; cy += (ty-cy)*.045;
        jonc.rotation.z = t*.28 + cx*1.4; gems.rotation.z = jonc.rotation.z;
        jonc.position.x = cx*.7; jonc.position.y = -cy*.7; gems.position.copy(jonc.position);
        goldPt.position.set(2+cx*4, -2-cy*3, 3);
        renderer.render(scene, camera);
      })();
    }catch(err){ /* dégradé gracieux : le fond CSS suffit */ }
  }

  /* ==========================================================================
     Galerie scroll — révélation dramatique + parallaxe
     ========================================================================== */
  function initScrollProduits(){
    var items = document.querySelectorAll('[data-amy-scroll-reveal]');
    if (!items.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      }, { threshold: 0.25 });
      items.forEach(function(el){ io.observe(el); });
    } else {
      items.forEach(function(el){ el.classList.add('is-visible'); });
    }

    var parallaxEls = document.querySelectorAll('[data-amy-parallax]');
    if (parallaxEls.length) {
      var ticking = false;
      function updateParallax(){
        parallaxEls.forEach(function(img){
          var r = img.parentElement.getBoundingClientRect();
          var vh = window.innerHeight;
          var progress = (vh - r.top) / (vh + r.height);
          var offset = (progress - 0.5) * 60;
          img.style.transform = 'translateY(' + offset + 'px)';
        });
        ticking = false;
      }
      window.addEventListener('scroll', function(){
        if (!ticking) { ticking = true; requestAnimationFrame(updateParallax); }
      }, { passive: true });
      updateParallax();
    }
  }

  /* ==========================================================================
     Page produit — glare métallique + tilt 3D sur l'image
     ========================================================================== */
  function initProductGlow(){
    var wrappers = document.querySelectorAll('.product__media-wrapper, .product__media-item');
    wrappers.forEach(function(el){
      el.classList.add('amy-media-glow');
      el.addEventListener('pointermove', function(e){
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width;
        var y = (e.clientY - r.top) / r.height;
        el.style.setProperty('--pg-x', (x*100) + '%');
        el.style.setProperty('--pg-y', (y*100) + '%');
        var media = el.querySelector('img, video');
        if (media) {
          var rx = (y - 0.5) * -8;
          var ry = (x - 0.5) * 10;
          media.style.transform = 'perspective(1200px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
        }
      });
      el.addEventListener('pointerleave', function(){
        var media = el.querySelector('img, video');
        if (media) media.style.transform = '';
      });
    });

    document.addEventListener('click', function(e){
      if (e.target.closest('.product-form__submit, .shopify-payment-button')) haptique([15,30,10,30,15]);
    });
    document.addEventListener('change', function(e){
      if (e.target.closest('.product-form, variant-selects, product-info')) haptique([10]);
    });
  }

  /* ==========================================================================
     Barre d'achat flottante au scroll (produit)
     ========================================================================== */
  function initBarreFlottante(){
    var barre = document.getElementById('amy-barre-flottante');
    if (!barre) return;
    var declencheur = document.querySelector('[data-amy-pdp-add], .product-form__buttons, .product-form__submit');
    if (!declencheur) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        barre.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(declencheur);

    var btn = barre.querySelector('[data-amy-barre-add]');
    if (btn) {
      btn.addEventListener('click', function(){
        var mainBtn = document.querySelector('[data-amy-pdp-add], .product-form__submit');
        if (mainBtn) mainBtn.click();
      });
    }
  }

  /* ==========================================================================
     Fiche produit sur mesure — variantes, quantité, panier réel, zoom
     ========================================================================== */
  function initPDP(){
    var root = document.querySelector('[data-amy-pdp]');
    if(!root) return;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-amy-variants]').textContent); } catch(e){ return; }
    var groups = root.querySelectorAll('[data-amy-option]');
    var priceEl = root.querySelector('[data-amy-price]');
    var cmpEl = root.querySelector('[data-amy-compare]');
    var addBtn = root.querySelector('[data-amy-pdp-add]');
    var buyBtn = root.querySelector('[data-amy-pdp-buy]');
    var label = root.querySelector('[data-amy-add-label]');
    var qty = root.querySelector('[data-amy-qty]');
    var current = variants.filter(function(v){ return String(v.id) === root.getAttribute('data-variant'); })[0] || variants[0];

    function chosen(){
      return Array.prototype.map.call(groups, function(g){ var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(){
      var s = chosen();
      if(!groups.length) return variants[0];
      return variants.filter(function(v){ return v.options.every(function(o, i){ return o === s[i]; }); })[0];
    }
    function mx(){ return (current && current.max) ? current.max : 10; }
    function q(){ var n = parseInt(qty.value, 10); return (n > 0 ? Math.min(n, mx()) : 1); }
    function apply(v, scroll){
      current = v;
      if(!v){ addBtn.disabled = true; buyBtn.disabled = true; label.textContent = 'Unavailable'; return; }
      priceEl.textContent = v.price;
      if(v.compare){ cmpEl.textContent = v.compare; cmpEl.hidden = false; } else { cmpEl.hidden = true; }
      addBtn.disabled = !v.available; buyBtn.disabled = !v.available;
      label.textContent = v.available ? 'Add to bag' : 'Sold out';
      qty.max = mx(); qty.value = q();
      try { history.replaceState(null, '', '?variant=' + v.id); } catch(e){}
      if(scroll && v.media){
        var fig = root.querySelector('[data-media-id="' + v.media + '"]');
        if(fig) fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    groups.forEach(function(g){ g.addEventListener('change', function(){ apply(find(), true); haptique([10]); }); });

    root.querySelector('[data-amy-qty-minus]').addEventListener('click', function(){ qty.value = Math.max(1, q() - 1); });
    root.querySelector('[data-amy-qty-plus]').addEventListener('click', function(){ qty.value = Math.min(mx(), q() + 1); });
    qty.addEventListener('change', function(){ qty.value = q(); });

    addBtn.addEventListener('click', function(){
      if(!current || !current.available || !window.AmyPanier) return;
      label.textContent = 'Adding…';
      window.AmyPanier.ajouter([{ id: current.id, quantity: q() }])
        .then(function(){ label.textContent = 'Added ✓'; setTimeout(function(){ label.textContent = 'Add to bag'; }, 1400); })
        .catch(function(){ label.textContent = 'Max in stock'; setTimeout(function(){ label.textContent = 'Add to bag'; }, 1600); });
    });
    buyBtn.addEventListener('click', function(){
      if(!current || !current.available) return;
      buyBtn.textContent = 'One moment…';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({ items:[{ id: current.id, quantity: q() }] }) })
        .then(function(r){ if(!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
        .catch(function(){ buyBtn.textContent = 'Sold out'; });
    });

    root.querySelectorAll('.amy-pdp-fig').forEach(function(fig){
      fig.addEventListener('pointermove', function(e){
        var r = fig.getBoundingClientRect();
        fig.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        fig.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  /* ==========================================================================
     Navigation — menu catégories (mega menu) + menu mobile
     ========================================================================== */
  function initNavMenu(){
    var cat = document.querySelector('[data-amy-cat]');
    if(cat){
      var caret = cat.querySelector('[data-amy-cat-toggle]');
      function closeCat(){ cat.classList.remove('is-open'); caret.setAttribute('aria-expanded','false'); }
      function openCat(){ cat.classList.add('is-open'); caret.setAttribute('aria-expanded','true'); }
      caret.addEventListener('click', function(e){
        e.preventDefault();
        if(cat.classList.contains('is-open')) closeCat(); else openCat();
      });
      document.addEventListener('click', function(e){ if(!cat.contains(e.target)) closeCat(); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCat(); });
      cat.addEventListener('mouseleave', closeCat);
    }

    var burger = document.getElementById('amy-ouvrir-menu');
    var panneau = document.getElementById('amy-menu-mobile');
    var voile = document.getElementById('amy-voile-menu');
    var fermer = document.getElementById('amy-fermer-menu');
    if(burger && panneau){
      function openMenu(){ panneau.classList.add('ouvert'); voile.classList.add('visible'); burger.setAttribute('aria-expanded','true'); }
      function closeMenu(){ panneau.classList.remove('ouvert'); voile.classList.remove('visible'); burger.setAttribute('aria-expanded','false'); }
      burger.addEventListener('click', openMenu);
      if(fermer) fermer.addEventListener('click', closeMenu);
      if(voile) voile.addEventListener('click', closeMenu);
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeMenu(); });
      panneau.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    initPreloader();
    initReveal();
    initProgress();
    initMagnetic();
    initTilt();
    initMarquee();
    initAvis();
    initCompteurs();
    initNewsletter();
    initProductGlow();
    initScrollProduits();
    initBarreFlottante();
    initPDP();
    initAtelier();
    initResonateur();
    initNavMenu();
  });
})();
